import React from 'react'
import { MODULE_KEYS, FAQ_DEFAULTS } from '../../moduleRegistry'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { FAQSection, FAQEntry } from './FAQSection'

type FAQConfig = {
  faqHeading: string
  faqs: FAQEntry[]
  [key: string]: unknown
}

/** Content for the FAQ tab. Reads its own `faq_module` slice. */
export const FAQPanel = () => {
  const { faqHeading, faqs } = useModuleConfig<FAQConfig>(MODULE_KEYS.faq, FAQ_DEFAULTS)
  return <FAQSection heading={faqHeading} faqs={faqs} />
}
